import CountWords from '@/src/components/CountWords/CountWords';
import LinkLibrary from '@/src/constrains/LinkLibrary';
import classname from 'classnames';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Input, OriSelect } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import _ContentPage from 'src/components/Modules/Components/ContentImageDragItem/index2';
import { errKeys } from 'src/components/Modules/Components/ContentImageDragItem/tools';
import Switcher from 'src/components/SectionSwitcher';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  EColType,
  generateCol,
} from 'src/pages/SalesChannelContentEditor/SalesChannelMegaMenu/common';
import {
  errKey,
  generateErrorKey,
  splitErrorKey,
} from 'src/pages/SalesChannelContentEditor/SalesChannelMegaMenu/tools';
import { i18nGet } from 'src/tools/tools';
import Navigation from '../Navigation';
import Product from '../Product';
import css from './css.module.less';

const Option = OriSelect.Option;

export enum ECol {
  col1 = 'col1',
  col2 = 'col2',
  col3 = 'col3',
  col4 = 'col4',
}

const Menu = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const p: any = useParams();
  const { contentUuid } = p;
  const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });

  const {
    data,
    onTitleChange,
    onLinkModuleChange,
    onTypeChange,
    onContentPageChange,
    onNavigationChange,
    onProductChange,
    contentPages,
    navigationList,
    id,
    error = {},
    isPrimary,
  } = props;

  const titleError = error[errKey.megaMenuTitle] || [];
  const { title, menuColumns, linkModule } = data || {};

  const [col1, col2, col3, col4] = menuColumns || [];
  const [selected, setSelected] = React.useState(ECol.col1);

  const mappedError = Object.keys(error).reduce((pre, now) => {
    if (now === errKey.megaMenuTitle) {
      return pre;
    } else {
      const hasError = (error[now] || []).length > 0;
      if (hasError) {
        const index = splitErrorKey(now)[1];
        //console.log('now', now);
        return {
          ...pre,
          [`col${index}`]: true,
        };
      } else {
        return pre;
      }
    }
  }, {});

  //console.log('mappedError', mappedError);

  const itemGenerate = (data, index: number) => {
    const i = index.toString();
    const contentPageInvalidError =
      error[generateErrorKey(errKey.megaMenuContentPageInvalid, i)];
    const contentPageError =
      error[generateErrorKey(errKey.megaMenuContentPage, i)];

    const contentPageImageError =
      error[generateErrorKey(errKey.megaMenuContentPageImage, i)];
    const contentPageSubtitleError =
      error[generateErrorKey(errKey.megaMenuContentPageSubtitle, i)];
    const contentPageSummaryError =
      error[generateErrorKey(errKey.megaMenuContentPageSummary, i)];

    return (
      <Dispatcher
        isPrimary={isPrimary}
        error={{
          contentPage: {
            contentPage: contentPageError,
            image: contentPageImageError,
            subtitle: contentPageSubtitleError,
            summary: contentPageSummaryError,
            contentPageInvalid: contentPageInvalidError,
          },
        }}
        onContentPageChange={onContentPageChange}
        onNavigationChange={onNavigationChange}
        onProductChange={onProductChange}
        data={data || generateCol()}
        colIndex={index}
        onTypeChange={onTypeChange}
        contentPages={contentPages}
        navigationList={navigationList}
        id={id}
      />
    );
  };

  return (
    <React.Fragment>
      <Section size='small' bottomBorder className={css.fieldSectionWrap}>
        <ItemWrapper
          title={`${getI18n('general.customer.title')}*`}
          size='small'
          rightPart={
            <CountWords count={(title || '').length} allCount={100} />
          }>
          <Input
            maxLength={100}
            value={title}
            onChange={onTitleChange}
            size='large'
            error={titleError.length > 0}
            help={titleError.join(' ')}
          />
        </ItemWrapper>
        {/* <div style={{ display: 'none' }}> */}
        {/* UXPSA-7091 */}
        <LinkLibrary
          data={linkModule}
          onChange={onLinkModuleChange}
          linkSet={linkSet}
        />
        {/* </div> */}
      </Section>
      {/* <Section size='small'> */}
      <Switcher
        selectContainer={css.switchContainer}
        selected={selected}
        onChange={setSelected}
        allSections={{
          [ECol.col1]: {
            title: `${getI18n('salesChannelContent.index.menuColumn')} 1`,
            hasError: mappedError['col0'],
            child: itemGenerate(col1, 0),
          },
          [ECol.col2]: {
            title: `${getI18n('salesChannelContent.index.menuColumn')} 2`,
            hasError: mappedError['col1'],
            child: itemGenerate(col2, 1),
          },
          [ECol.col3]: {
            title: `${getI18n('salesChannelContent.index.menuColumn')} 3`,
            hasError: mappedError['col2'],
            child: itemGenerate(col3, 2),
          },
          [ECol.col4]: {
            title: `${getI18n('salesChannelContent.index.menuColumn')} 4`,
            hasError: mappedError['col3'],
            child: itemGenerate(col4, 3),
          },
        }}
      />
      {/* </Section> */}
    </React.Fragment>
  );
};
export default Menu;

const Dispatcher = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    data,
    onTypeChange,
    colIndex,
    onContentPageChange,
    onNavigationChange,
    onProductChange,
    contentPages,
    id,
    navigationList,
    error,
    isPrimary,
  } = props;

  const { columnType } = data || {};
  const render = () => {
    if (columnType === EColType.ContentPage) {
      const { image, summary, subtitle, contentPage } = data || {};
      const { contentPage: contentPageError } = error;
      return (
        <Section size='small' className={css.contentPageContainer}>
          <_ContentPage
            index={0}
            isPrimary={isPrimary}
            specificError={contentPageError}
            errKeys={errKeys}
            selectedPages={contentPages || []}
            sectionContainer={css.contentPageSectionContainer}
            contentPage={contentPage}
            image={image}
            summary={summary}
            subtitle={subtitle}
            onChange={(_, target) => {
              if (onContentPageChange) {
                onContentPageChange(colIndex, target);
              }
            }}
          />
        </Section>
      );
    }
    if (columnType === EColType.Product) {
      const { salesChannelProduct } = data || {};
      const _data = salesChannelProduct ? [salesChannelProduct] : null;
      return (
        <Product
          isPrimary={isPrimary}
          data={_data}
          onChange={(target) => {
            if (onProductChange) {
              onProductChange(colIndex, target);
            }
          }}
        />
      );
    }
    if (columnType === EColType.NavigationGroup) {
      const { menuGroups } = data;
      return (
        <Navigation
          isPrimary={isPrimary}
          navigationList={navigationList || []}
          droppableId={`SalesChannelMegaMenuNaviGroup${colIndex}${id}`}
          data={menuGroups || []}
          onChange={(data) => {
            if (onNavigationChange)
              onNavigationChange(colIndex, { menuGroups: data });
          }}
        />
      );
    }
    return null;
  };
  return (
    <React.Fragment>
      <div className={css.typeSelector}>
        <ItemWrapper
          title={`${getI18n('salesChannelContent.index.menuColumnType')}*`}
          size='small'
          containerClassName={classname(css.menuColumnType)}>
          <OriSelect
            disabled={!isPrimary}
            size='large'
            value={columnType}
            onChange={(e) => {
              if (onTypeChange) {
                onTypeChange(colIndex, e);
              }
            }}>
            <Option value={EColType.NavigationGroup}>
              {getI18n('salesChannelContent.index.navigationGroup')}
            </Option>
            <Option value={EColType.ContentPage}>
              {getI18n('general.sider.contentPage')}
            </Option>
            <Option value={EColType.Product}>
              {getI18n('general.storeCommunicationSetting.product')}
            </Option>
          </OriSelect>
        </ItemWrapper>
      </div>

      {render()}
    </React.Fragment>
  );
};
